module.exports = __webpack_public_path__ + "img/ticket.6e883243.svg";